module.exports = __webpack_public_path__ + "media/3.d451b245.wav";